import { Lead } from "../../../../Models/Lead";
import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import UserContextValueProvider from "../../../Providers/Value/UserContextValueProvider";
import IntroGreeting from "../Components/IntroGreeting";

/** Provides the Customer First Name and Lead External System Session Context properties. */
const SessionContextGreeting = SessionContextValueProvider({
  Component: IntroGreeting,
  map: ({ customer, lead }) => {
    return {
      customerFirstName: customer.firstName,
      outbound: Lead.isOutboundDirection(lead)
    };
  }
});

/** Provides the User First Name User Context Property. */
const UserAndSessionContextGreeting = UserContextValueProvider({
  Component: SessionContextGreeting,
  map: ({ user }) => {
    return { userFirstName: user.firstName };
  }
});

export default UserAndSessionContextGreeting;
